export default __webpack_public_path__ + "41bd8d36ec102e3260cfc1ad8dcff740.png";